<template>
	<div class='con'>
		<code-login ref="myCodeLogin" @update-page="updatePage"></code-login>
		<head-top head-title="购买须知" goBack="true"></head-top>

		<div class='main order_agreement'>
			<div v-html="content" style="white-space: pre-wrap;"></div>
			<div class="btn_next bg_c color_b font_size_c" @click="topaypage()">
				同意，下一步
			</div>
		</div>
	</div>
</template>

<script>
	import headTop from '@/components/common/head.vue'
	import api from '@/apis/api'
	import tool from "@/common/tool";
	import {
		mapGetters,
		mapActions
	} from 'vuex';
	export default {
		name: 'GroupCurriculumOrderAgreement',
		components: {
			headTop: headTop
		},
		data() {
			return {
				resourceDomain: api.resourceDomain,
				content: null,
				skuId: null,
				joinId: null,
				curriculumId: null
			}
		},

		created() {
			this.token = this.getToken()
			this.skuId = this.$route.query.skuId
			this.curriculumId = this.$route.query.curriculumId
			this.joinId = this.$route.query.joinId
			sessionStorage.removeItem("GROUP_WAITING_PAY_ORDER")
			this.curriculumOrderExplain()
		},
		computed: {
			...mapGetters('userModule', ['getToken'])
		},

		methods: {
			...mapActions("userModule", ["SET_OPENID"]),

			// 调用组件中的登录成功里的自定义的更新数据事件
			updatePage() {
				this.token = this.getToken()
				this.curriculumOrderExplain()
			},

			curriculumOrderExplain() {
				api.get('/curriculum/curriculumOrderExplain').then((res) => {
					if (res.success) {
						this.content = res.data.content
					} else {
						this.$toast(res.message);
					}
				})
			},

			topaypage() {
				if (this.getToken()) {
					var groupCurriculum_waiting_pay = {
						curriculumId: this.curriculumId,
						skuId: this.skuId,
						joinId: this.joinId
					}
					sessionStorage.setItem('GROUP_WAITING_PAY_ORDER', JSON.stringify(
						groupCurriculum_waiting_pay)) //涉及到微信支付页面跳转后redirect_url会自动截断参数问题
					console.log("isWxEnv===========================>" + tool.isWxEnv())
					// 如果是在微信网页内支付，就需要先获取code，再用code获取openid
					if (tool.isWxEnv()) {
						let url = encodeURIComponent(api.aPI_BASE_URL + "/#/curriculum_confirm_order_group")
						window.location.href = tool.getCOdeBySnsapiBase(url);
					} else {
						this.$router.replace({
							path: '/curriculum_confirm_order_group'
						})
					}
				} else {
					this.$store.commit('userModule/SET_login_popup_show', true)
				}
			}

		}
	}
</script>

<style>
	.order_agreement img {
		max-width: 100% !important;
		height: auto !important;
	}
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
	.main {
		margin-top: 48px;
		padding: 15px;
	}

	.btn_next {
		margin-top: 40px;
		width: 100%;
		text-align: center;
		height: 45px;
		line-height: 45px;
		border-radius: 22.5px;
	}
</style>